module.exports = __webpack_public_path__ + "static/media/megafon.54e75506.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/instagram-promo/megafon.png
// module id = 2463
// module chunks = 7